import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AnnualPlanService } from '../../providers/annual-plans.services';
import { Subscription } from 'rxjs';
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent, MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { AnnualPlan } from "../../../common/models/annual-plan";
import { Athlete } from "../../../common/models/athlete";
import { AthleteRow, AthletesProvider } from "../../../athletes/providers/athletes-provider";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { TranslateModule } from "@ngx-translate/core";
import { MatError, MatFormField, MatLabel } from "@angular/material/form-field";
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerModule,
  MatDatepickerToggle
} from "@angular/material/datepicker";
import { MatOption, MatSelect, MatSelectModule } from "@angular/material/select";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { NgForOf, NgIf } from "@angular/common";

@Component({
  selector: 'annual-plan-dialog-assign-to',
  templateUrl: './annual-plan-dialog-form-assign-to.component.html',
  styleUrls: ['./annual-plan-dialog-form-assign-to.scss'],
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    MatFormField,
    MatDialogModule,
    MatSelectModule,
    MatDatepickerModule,
    MatLabel,
    MatError,
    MatInput,
    MatButton,
    NgForOf,
    NgIf,
  ],
  standalone: true
})
export class AnnualPlanDialogFormAssignToComponent implements OnInit, OnDestroy {

    public assignPlanForm: FormGroup;
    public isSubmitting = false;
    public annualPlans: AnnualPlan[] = [];
    public annualPlan: AnnualPlan = {} as AnnualPlan;
    public startDate: Date = new Date();
    public athletes: Athlete[] = [];
    public rows: any;
    private subscriptions: Subscription[] = [];

    constructor(
        public dialog: MatDialogRef<AnnualPlanDialogFormAssignToComponent>,
        private utils: UtilsProvider,
        private fb: FormBuilder,
        private annualPlanProvider: AnnualPlanService,
        private athleteProvider: AthletesProvider,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        // use the FormBuilder to create a form group
        this.assignPlanForm = this.fb.group({
            athlete: new FormControl(null, [Validators.required]),
            startedAt: new FormControl(this.startDate, [Validators.required])
        });
    }

    public ngOnInit() {
        this.athleteProvider.getAthleteRows(this.data.organization.id).subscribe({
            next: (rows) => {
                this.rows = rows;
            }
        });
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public submitForm() {
        this.isSubmitting = true;

        if (this.assignPlanForm.valid) {
            Object.assign(this.annualPlan, this.data.annualPlanRow);

            this.subscriptions.push(
                this.annualPlanProvider.assignPlanToAthlete(
                    this.data.organization,
                    this.annualPlan,
                  this.assignPlanForm.controls['athlete'].value,
                  this.assignPlanForm.controls['startedAt'].value
                ).subscribe((data:any) => {
                    this.dialog.close({annualPlan: data, toDelete: false});
                })
            );

            // copy library annual plan as an athlete annual plan
        } else {
            this.utils.validateAllFormFields(this.assignPlanForm);
            this.isSubmitting = false;
        }
    }

    get f() {
        return this.assignPlanForm.controls;
    }

  get startedAtControl(): FormControl {
    return this.assignPlanForm.get('startedAt') as FormControl;
  }

  protected readonly FormControl = FormControl;
}
